/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components
 |--------------------------------------------------------------------------
 |
 | Here we will load the Spark components which makes up the core client
 | application. This is also a convenient spot for you to load all of
 | your components that you write while building your applications.
 */

require('./../spark-components/bootstrap')

// Utilities
// Vue.component('favorite-toggle', require('./components/favorite-toggle.vue').default);
Vue.component('toggle', require('./components/toggle.vue').default)
Vue.component('list', require('./components/list.vue').default)
Vue.component('grid', require('./components/grid.vue').default)
Vue.component('element-filter', require('./components/element-filter.vue').default)
Vue.component('tab-navigation', require('./components/tab-navigation.vue').default)
Vue.component('quiz', require('./components/quiz.vue').default)
Vue.component('search-input', require('./components/search-input.vue').default)
Vue.component('user-preferences', require('./mixins/user-preferences.js'))
Vue.component('video-player', require('./components/video-player.vue').default)
Vue.component('flash-message', require('./components/flash-message.js'))
Vue.component('search-status', require('./components/search-status.vue').default)
Vue.component('back-to-top', require('./components/back-to-top.vue').default)
Vue.component('favorite-toggle', require('./components/favorite-toggle.vue').default)
// Vue.component('completed-toggle', require('./components/completed-toggle.vue'));
Vue.component('contact-form', require('./components/contact-form.vue').default)
Vue.component('favorites-list', require('./components/favorites-list.js'))
Vue.component('segment-ingredients', require('./components/segment-ingredients.js'))

// List Items
// Vue.component('simple-favorites', require('./list-items/simple-favorites.vue'));
Vue.component('wildcard', require('./list-items/wildcard.vue').default)
Vue.component('course-card', require('./list-items/course-card.vue').default)
Vue.component('course-card-horizontal', require('./list-items/course-card-horizontal.vue').default)
Vue.component('lesson-card', require('./list-items/lesson-card.vue').default)
Vue.component('lesson-card-horizontal', require('./list-items/lesson-card-horizontal.vue').default)
Vue.component('user-activity', require('./list-items/user-activity.vue').default)
Vue.component('article-card', require('./list-items/article-card.vue').default)
Vue.component('user-devices', require('./list-items/user-devices.vue').default)

// Card Parts
Vue.component('card-status', require('./components/card-status.vue').default)
Vue.component('card-difficulty', require('./components/card-difficulty.vue').default)

// Pages
Vue.component('page-course', require('./pages/course.js'))
Vue.component('page-dashboard', require('./pages/dashboard.js'))
Vue.component('page-lesson', require('./pages/lesson.js'))
Vue.component('page-library', require('./pages/library.js'))
Vue.component('page-glossary', require('./pages/glossary.js'))
Vue.component('page-articles', require('./pages/articles.js'))
Vue.component('page-questionnaire', require('./pages/questionnaire.js'))
Vue.component('page-my-book', require('./pages/my-book.js'))
Vue.component('page-enterprise', require('./pages/enterprise.vue').default)
Vue.component('page-activities', require('./pages/activities.vue').default)
